export function whoIsRejecter(item) {
    if (!item.rejecter)
        return "no";
    if (item.rejecter === item.checker &&
        item?.rejectedDate &&
        !item?.checkedDate)
        return "checker";
    return "approver";
}
